import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_RESULT_TAPPED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
  RESULT_TYPE: '',
  SUGGESTED_DOC: false, // always false on web
  SEARCH_QUERY_TERM: null,
  LIST_POSITION: 0, // 1-indexed
});

const RECORD = generateSchema(TRACKING_RESULT_TAPPED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_RESULT_TAPPED_SCHEMA);

export class ResultTappedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.result_tapped;
  }

  get properties() {
    return this.toJS();
  }
}
